<div *ngIf="isKYCAccessible; else KYCNotAccessible" id="sumsub-websdk-container"></div>
<ng-template #KYCNotAccessible>
  <p>{{ 'auth.KYC.to_use_all_features' | translate }}</p>
  <div class="button-area">
    <a href="#" class="subheader2 mr-3" (click)="close($event)">{{ 'common.cancel' | translate }}</a>
    <button pButton [label]="'auth.KYC.go_to_kyc' | translate" (click)="getKYCToken()"></button>
  </div>
</ng-template>
